// Utility to crop an image using canvas (for use with react-easy-crop)
// Usage: getCroppedImg(imageSrc, crop, zoom, aspect) => Promise<Blob>

export async function getCroppedImg(imageSrc, crop, zoom = 1, aspect = 1) {
  const createImage = (url) => {
    return new Promise((resolve, reject) => {
      const image = new window.Image();
      image.addEventListener('load', () => resolve(image));
      image.addEventListener('error', (error) => reject(error));
      image.setAttribute('crossOrigin', 'anonymous'); // Needed for cross-origin images
      image.src = url;
    });
  };

  const image = await createImage(imageSrc);
  const naturalWidth = image.naturalWidth;
  const naturalHeight = image.naturalHeight;

  // Calculate crop area in pixels
  // react-easy-crop already gives us *pixel* coordinates via `croppedAreaPixels`,
  // so we can use the values directly.  Earlier code assumed percentages which
  // resulted in wildly incorrect crops.  We also clamp the values to the image
  // bounds to avoid out-of-range errors on some browsers.
  const cropX = Math.max(0, crop.x);
  const cropY = Math.max(0, crop.y);
  const cropWidth = Math.min(crop.width, naturalWidth - cropX);
  const cropHeight = Math.min(crop.height, naturalHeight - cropY);

  // Create a canvas to draw the cropped image
  const canvas = document.createElement('canvas');
  canvas.width = cropWidth;
  canvas.height = cropHeight;
  const ctx = canvas.getContext('2d');

  // Draw the cropped image
  ctx.drawImage(
    image,
    cropX,
    cropY,
    cropWidth,
    cropHeight,
    0,
    0,
    cropWidth,
    cropHeight
  );

  // Convert canvas to Blob (JPEG, 0.9 quality)
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    }, 'image/jpeg', 0.9);
  });
}
